import { supabase } from "@/integrations/supabase/client";
import { useQuery } from "@tanstack/react-query";

const useIsValidReferralCode = (referralCode?: string) => {
  const queryResult = useQuery({
    queryKey: ["is-valid-referral-code", referralCode],
    queryFn: async () => {
      if (!referralCode) return false;
      const { data, error } = await supabase
        .from("profiles")
        .select(`id`)
        .eq("referral_code", referralCode)
        .maybeSingle();

      if (error) {
        console.error("Error checking referral code:", error);
        return false;
      }

      return Boolean(data?.id);
    },
    enabled: !!referralCode,
  });

  return queryResult;
};

export default useIsValidReferralCode;